import React from 'react';
import { PaymentElement, useCheckout } from '@stripe/react-stripe-js';

const CheckoutForm = ({ onClose, isTrial }: { onClose?: () => void, isTrial?: boolean }) => {
  const checkout = useCheckout();
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<any>(null);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    checkout.confirm().then((result) => {
      if (result.type === 'error') {
        setError(result?.error);
        setLoading(false);
      }
      // Success case will redirect to success page
    }).catch((err) => {
      setError(err);
      setLoading(false);
    });
  };

  return (
    <div className="w-full">
      <div className="mb-6">
        <PaymentElement 
          options={{
            layout: { 
              type: 'accordion',
              defaultCollapsed: false,
              radios: false,
              spacedAccordionItems: true
            },
            fields: {
              billingDetails: 'auto'
            },
            terms: {
              card: 'never'
            }
          }} 
        />
      </div>

      {error && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
          <p className="text-red-600 text-sm">{error.message}</p>
        </div>
      )}

      <div className="flex flex-col sm:flex-row gap-3">
        <button
          type="button"
          disabled={loading}
          onClick={handleClick}
          className={`flex-1 py-3 px-4 rounded-lg font-semibold text-sm transition-all duration-200 btn ${
            loading 
              ? 'bg-gray-400 cursor-not-allowed' 
              : 'active-bg hover:bg-blue-700 transform hover:scale-[1.02]'
          } text-theme-primary shadow-lg`}
        >
          {loading ? (
            <span className="flex items-center justify-center">
              <div className="animate-spin w-4 h-4 border-2 border-white border-t-transparent rounded-full mr-2"></div>
              Processing...
            </span>
          ) : (
            !isTrial ? 'Subscribe Now' : 'Subscribe Now'
          )}
        </button>
        
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="flex-1 sm:flex-initial px-6 py-3 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
        )}
      </div>

      
    </div>
  );
};

export default CheckoutForm;